import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
//
require('./style.css');

interface IProps {
	t?: (key: string) => string;
	whiteIcons: boolean;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class SocialButtons extends React.Component<IProps, any> {
	public render() {
		const { whiteIcons } = this.props;
		const content: JSX.Element[] = [];
		const { t } = this.props;

		if (whiteIcons) {
			content.push(
				<div key="socialButtons" className="socialButtons">
					<a href={t('Navigation_Main_Magazine_Socials_FbUrl')} className="fb" target="_blank" rel="noreferrer">
						<img src={require('containers/Html/icons/social/fb_white.svg')} className="icon" />
					</a>
					<a href={t('Navigation_Main_Magazine_Socials_TwitterUrl')} className="twitt" target="_blank" rel="noreferrer">
						<img src={require('containers/Html/icons/social/twitt_white.svg')} className="icon" />
					</a>
					<a href={t('Navigation_Main_Magazine_Socials_YouTubeUrl')} className="yt" target="_blank" rel="noreferrer">
						<img src={require('containers/Html/icons/social/yt_white.svg')} className="icon" />
					</a>
					<a
						href={t('Navigation_Main_Magazine_Socials_InstagramUrl')}
						className="insta"
						target="_blank"
						rel="noreferrer"
					>
						<img src={require('containers/Html/icons/social/insta_white.svg')} className="icon" />
					</a>
					<a
						href={t('Navigation_Main_Magazine_Socials_PinterestUrl')}
						className="pint"
						target="_blank"
						rel="noreferrer"
					>
						<img src={require('containers/Html/icons/social/pint_white.svg')} className="icon" />
					</a>
					<div className="clear" />
				</div>,
			);
		} else {
			content.push(
				<div key="socialButtons" className="socialButtons">
					<a href={t('Navigation_Main_Magazine_Socials_FbUrl')} className="fb" target="_blank" rel="noreferrer">
						<img src={require('containers/Html/icons/social/fb.svg')} className="icon" />
					</a>
					<a href={t('Navigation_Main_Magazine_Socials_TwitterUrl')} className="twitt" target="_blank" rel="noreferrer">
						<img src={require('containers/Html/icons/social/twitt.svg')} className="icon" />
					</a>
					<a href={t('Navigation_Main_Magazine_Socials_YouTubeUrl')} className="yt" target="_blank" rel="noreferrer">
						<img src={require('containers/Html/icons/social/yt.svg')} className="icon" />
					</a>
					<a
						href={t('Navigation_Main_Magazine_Socials_InstagramUrl')}
						className="insta"
						target="_blank"
						rel="noreferrer"
					>
						<img src={require('containers/Html/icons/social/insta.svg')} className="icon" />
					</a>
					<a
						href={t('Navigation_Main_Magazine_Socials_PinterestUrl')}
						className="pint"
						target="_blank"
						rel="noreferrer"
					>
						<img src={require('containers/Html/icons/social/pint.svg')} className="icon" />
					</a>
					<div className="clear" />
				</div>,
			);
		}

		return content;
	}
}

export { SocialButtons };
